import { gql, useQuery } from "@apollo/client";
import { campaignRecommendationsWithOffersQueryQuery, CampaignRecommendationsWithOffersQuery } from "__generated__/api";
import CampaignRecommendations = CampaignRecommendationsWithOffersQuery.CampaignRecommendations;

const campaignRecommendationsWithOffersQuery = gql`
  ${campaignRecommendationsWithOffersQueryQuery}
`;

export type CampaignRecommendationsWithOffersResponse = { campaignRecommendations: CampaignRecommendations };

type FetchOptions = {
  variables: CampaignRecommendationsWithOffersQuery.Variables;
  updateQuery: (
    previousQueryResult: any,
    options: {
      fetchMoreResult?: any;
      variables?: CampaignRecommendationsWithOffersQuery.Variables;
    }
  ) => any;
};

type FechMore = (options: FetchOptions) => void;

export function useCampaignRecommendationsWithOffersQuery(variables: CampaignRecommendationsWithOffersQuery.Variables) {
  const response = useQuery<CampaignRecommendationsWithOffersResponse>(campaignRecommendationsWithOffersQuery, {
    variables,
    ssr: false,
  });

  return { ...response, fetchMore: buildFetchMore(response.fetchMore, variables) };
}

export const buildFetchMore = (fetchMore: FechMore, currentVariables: any): FechMore => ({
  variables: newVariables,
}): void => {
  /* istanbul ignore next */
  fetchMore({
    updateQuery: (prev, { fetchMoreResult }) => {
      if (!fetchMoreResult) {
        return prev;
      }

      const prevCampaigns = prev.campaignRecommendations?.campaigns;
      const moreCampaigns = fetchMoreResult.campaignRecommendations?.campaigns;

      return {
        ...prev,
        campaignRecommendations: {
          ...prev.campaignRecommendations,
          paginationInfo: {
            ...prev.campaignRecommendations?.paginationInfo,
            ...fetchMoreResult.campaignRecommendations?.paginationInfo,
          },
          campaigns: [...prevCampaigns, ...moreCampaigns],
        },
      };
    },
    variables: {
      ...currentVariables,
      ...newVariables,
    },
  });
};

export default useCampaignRecommendationsWithOffersQuery;
